import validate from "/builds/skuby/e-shop-template/projects/web/node_modules/.bun/nuxt@4.3.1+a0ef9e983639d73c/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/skuby/e-shop-template/projects/web/node_modules/.bun/nuxt@4.3.1+a0ef9e983639d73c/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-scope": () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Auth/middleware/authScope.ts"),
  "un-auth-scope": () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Auth/middleware/unAuthScope.ts")
}